import { Box, Typography } from "@mui/material";
import { findBondAttorneyByGuardian } from "../utils/bondGuardianAttorneyWiring";

export default function SelectedAttorneySummary({
  attorneys,
  guardian,
  title = "Selected Attorney:",
  addressLabel = "Office Address",
}) {
  const attorney = findBondAttorneyByGuardian(attorneys, guardian);
  if (!guardian?.is_attorney || guardian.is_attorney !== "Yes" || !guardian.attorney || !attorney) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1">
        <strong>Name:</strong> {attorney.label}
      </Typography>
      <Typography variant="body1">
        <strong>Position:</strong> {attorney.position}
      </Typography>
      <Typography variant="body1">
        <strong>{addressLabel}:</strong> {attorney.address}
      </Typography>
      <Typography variant="body1">
        <strong>City/State/Zip:</strong> {attorney.city}, {attorney.state} {attorney.zip_code}
      </Typography>
    </Box>
  );
}
